<template>
  <div id="main_div">
    <!-- Home Section start-->
    <Home />
    <!--Home Section End -->

    <!-- Banner Section start-->
    <Banner />
    <!--Banner Section End -->

    <!-- About Start  -->
    <About />
    <!-- About End -->
    <Carouselpdf />
    <!-- Feature Section start -->
    <Feature />
    <!-- Feature Section End -->

    <!-- Screenshots Section Start -->
    <Screenshots />
    <!-- Screenshots Section End -->

    <product />
    <!-- testimonial Section start-->
    <!-- <Testimonial/> !-->
    <!-- testimonial Section End -->

    <!-- Contact Section start -->
    <Contact_us />
    <!-- Contact Section End -->

    <!--Subscribe section start-->
    <!-- <Subscribe/> !-->
    <!--Subscribe section Ends-->

    <!--Map Section Start-->
    <Map />
    <!--Map Section Ends-->

    <!-- Footer Section start -->
    <Footer />
    <!-- Footer Section End -->

    <js />

   
  </div>
</template>

<script>


export default {
  
  name: "Home_one",
  beforeCreate: function () {
    document.body.className = "";
  },
};
</script>

<style>
.home-right {
  top: 100px;
}
.hover-link:hover {
  color: #A9A9A9;
}
</style>



// WEBPACK FOOTER //
// src/demo_page/home_one.vue